import React, { Fragment, lazy, Suspense } from 'react';
import LazyLoader from '../../components/MasterLayout/LazyLoader';
const Shop = lazy(()=>import('../../components/Shop/Shop'))

const ShopPage = () => {
    return (
        <Fragment>
            <Suspense fallback={<LazyLoader/>}>
                <Shop/>
            </Suspense>
        </Fragment>
    );
};

export default ShopPage;